import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const recordPurchase = createAsyncThunk('payment/recordPurchase', async ({ contentId, txHash, walletAddress }, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/payment/record-purchase', { contentId, txHash, walletAddress });
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Error recording purchase');
  }
});

export const fetchPurchases = createAsyncThunk('payment/fetchPurchases', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get('/payment/purchases');
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data?.error || 'Error loading purchases');
  }
});

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    purchases: [],
    purchasing: false,
    error: null
  },
  reducers: {
    clearError(state) { state.error = null; },
    setPurchasing(state, action) { state.purchasing = action.payload; },
    setPaymentError(state, action) { state.error = action.payload; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(recordPurchase.fulfilled, (state, action) => { state.purchasing = false; state.purchases.push(action.payload); })
      .addCase(recordPurchase.rejected, (state, action) => { state.purchasing = false; state.error = action.payload; })
      .addCase(fetchPurchases.fulfilled, (state, action) => { state.purchases = action.payload; });
  }
});

export const { clearError, setPurchasing, setPaymentError } = paymentSlice.actions;
export default paymentSlice.reducer;
